import { colors } from '../../colors';
var richText = {
  backgroundColor: colors.whiteish,
  h1Color: colors.onyx,
  h2Color: colors.onyx,
  paraColor: colors.onyx,
  anchorColor: colors.cerulean
};
export default richText;